import imageUrl from "../../assets/lightbox/host-field-guide.svg";
import type { CaseView } from "./caseView";
/* UI-DESIGN: Case 00 is a real fourth scene object, an illustrated host
   field guide. It is never a catalogue record or a hostable mystery. */
export const HOW_CASE: CaseView = {
  id: "guide-how-it-works",
  number: "00",
  name: "The host’s field guide",
  premise: "Pick a case. Invite your friends. Live texts all night. You play too.",
  players: null,
  length: null,
  imageUrl,
};
